import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { EnumStatusAvaliacaoQuestionarioUG } from 'src/app/models/enum/status-avaliacao-questionario-ug.enum';
import { EnumTipoAvaliacaoQuestionarioUG } from 'src/app/models/enum/tipo-avaliacao-questionario-ug.enum';
import { EnumTipoDocumentoAprovacao } from 'src/app/models/enum/tipo-documento-aprovacao.enum';
import { EnumTipoQuestionarioUG } from 'src/app/models/enum/tipo-questionario-ug.enum';
import { AvaliacaoRequest } from 'src/app/models/questionario-ug.model';
import { QuestionarioUGRespostaService } from 'src/app/services/questionarioug-resposta.service';
import { TabelaDominioService } from 'src/app/services/tabela-dominio.service';
import { BaseFormComponent } from 'src/app/shared/components/base-form/base-form.component';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';

@Component({
  selector: 'app-modal-contestar',
  templateUrl: './modal-contestar.component.html',
  styleUrls: ['./modal-contestar.component.scss']
})
export class ModalContestarComponent extends BaseFormComponent  implements OnInit {
  form: FormGroup;  // Declarando o FormGroup
  opcoesAvaliacao = [
    { value: EnumStatusAvaliacaoQuestionarioUG.concordo, label: 'Concordo' },
    { value: EnumStatusAvaliacaoQuestionarioUG.concordoParcialmente, label: 'Concordo Parcialmente' },
    { value: EnumStatusAvaliacaoQuestionarioUG.discordo, label: 'Discordo' }
  ];
  EnumStatusAvaliacaoQuestionarioUG = EnumStatusAvaliacaoQuestionarioUG;
  avaliacao: AvaliacaoRequest;
  public titulo: string;
  htmlResposta: SafeHtml | undefined;
  perguntaOpcao: any;


  constructor(
    public route: ActivatedRoute,
    public toastr: ToastrService,
    public router: Router,
    public localeService: BsLocaleService,
    private tabelaDominioService: TabelaDominioService,
    private dialogRef: MatDialogRef<ModalContestarComponent>,
    public matDialog: MatDialog,
    private sanitizer: DomSanitizer,
    private fb: FormBuilder,
    private questionarioUGRespostaService: QuestionarioUGRespostaService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      pergunta: [this.data.pergunta],
      resposta: [this.data.resposta],
      tipoEntrada: [this.data.tipoEntrada],
      respostaRevisada: [''] ,  // Adicione o controle para resposta revisada
      statusAvaliacao: [null] // Adicione o controle para o select
    });

    this.perguntaOpcao = this.data.perguntaOpcao;

    // Log de debug para verificar mudanças no campo statusAvaliacao
    this.form.get('statusAvaliacao')?.valueChanges.subscribe((value) => {
      console.log('Valor selecionado:', value);
      if (value === '1') {
        console.log('Campo Resposta Revisada será ocultado.');
      }
    })

    if(this.data.tipoQuestionarioId == EnumTipoQuestionarioUG.EntendendoEntidade){
      this.titulo = "Entendendo a Entidade ";
    }else if (this.data.tipoQuestionarioId == EnumTipoQuestionarioUG.MaturidadeRisco){
      this.titulo = "Maturidade de gestão de risco";
    }
    const respostaHTML = this.data.resposta;

        // Atualize o controle do formulário
        this.form.get('resposta')?.setValue(respostaHTML);

        // Sanitizar o HTML para exibição segura
        this.htmlResposta = this.sanitizer.bypassSecurityTrustHtml(respostaHTML);

  }

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    sanitize: false,
    height: '15rem',
    minHeight: '5rem',
    placeholder: '',
    translate: 'yes',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'Arial',
    toolbarHiddenButtons: [
      // ['bold']
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText',
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
  };

  cancelar(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = { interno: true };
    this.matDialog.open(ModalCancelarComponent, dialogConfig).afterClosed();

  }
  salvar(salvarEFechar: boolean){
    const idsSelecionadosString: string = [this.data.ids].join(',');
    this.avaliacao = {
      statusAvaliacao: this.form.value.statusAvaliacao,
      texto: this.form.value.respostaRevisada,
      tipoAvaliacao: EnumTipoAvaliacaoQuestionarioUG.replica
    };

    this.questionarioUGRespostaService.fazerAvaliacaoOuReplica(idsSelecionadosString, this.avaliacao)
    .then((res) => {
      if (res.sucesso) {
        if(salvarEFechar){
          this.dialogRef.close();
        }
        this.exibirMensagemSucesso('Avaliacao Realizada com Sucesso');
        window.location.reload();
      }
      else{
        this.exibirMensagemErro(res.mensagem.descricao);
      }
    })

}
}
